var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSupport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Bounding_box",
    "data-name": "Bounding box"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.95771,10.17969C19.68806,6.95764,17.80805,2,11.99781,2s-7.69025,4.95764-7.9599,8.17969A2.79267,2.79267,0,0,0,2.19782,12.8v1.4a2.8,2.8,0,0,0,5.6,0V12.8a2.79774,2.79774,0,0,0-1.74652-2.59125C6.2533,8.37006,7.23389,4,11.99781,4c4.76465,0,5.74481,4.37152,5.94665,6.20868A2.79786,2.79786,0,0,0,16.19782,12.8v1.4a2.79227,2.79227,0,0,0,1.59308,2.51642c-.4231.7973-1.48694,1.86029-4.12555,2.18207a2.00579,2.00579,0,1,0,.11322,1.99432c4.29639-.48932,5.6662-2.7044,6.09552-4.04657A2.79079,2.79079,0,0,0,21.7978,14.2V12.8A2.79276,2.79276,0,0,0,19.95771,10.17969ZM5.7978,14.2a.8.8,0,1,1-1.6,0V12.8a.8.8,0,0,1,1.6,0Zm12.4-1.4a.8.8,0,0,1,1.6,0v1.4a.8.8,0,1,1-1.6,0Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/Support.5179932c.svg";
export { ForwardRef as ReactComponent };